export default "__VITE_ASSET__a8GgpWuJ__"